import { Row, Col } from 'react-bootstrap'
import projectSeenLogo from '../assets/projectseen.png'

const Portfolio = () => {
    const projects = [
        {
            title: "Social Media Insights Tool",
            clientImage: projectSeenLogo,
            description: "A consumer platform that allows users to view how their social media profiles appear across popular networks. The service provides a simple, unified dashboard where individuals can see their publicly shared content in one place—useful for personal branding, job seekers preparing for interviews, or anyone curious about their online image. It's a straightforward tool for self-awareness in the social media age.",
            subtitle: "Helping users explore and understand their online presence",
            tags: ["Consumer Platform", "Social Media", "Dashboard"]
        },
        {
            title: "Internal CRM Automation",
            client: "BrightPath Media",
            description: "Built a custom CRM integration that automated lead tracking, client communication, and reporting workflows. Reduced manual data entry by 70%.",
            tags: ["Automation", "API Integration", "Dashboard"]
        },
        {
            title: "AI Chatbot Integration",
            client: "Velora",
            description: "Developed and deployed an AI-powered customer service chatbot that handles product inquiries, order tracking, and returns processing.",
            tags: ["AI/ML", "Chatbot", "E-commerce"]
        },
        {
            title: "Operations Dashboard",
            client: "SwiftHaul Logistics",
            description: "Created a real-time data dashboard for tracking shipments, inventory levels, and delivery performance metrics across multiple warehouses.",
            tags: ["Data Visualization", "Real-time", "Analytics"]
        },
        {
            title: "Client Portal System",
            client: "Aldric & Partners",
            description: "Designed and built a secure client portal for document sharing, project tracking, and communication management.",
            tags: ["Web Application", "Security", "Document Management"]
        }
    ]

    return (
        <Row className="portfolio mx-0" id="portfolio">
            <Row className="mx-0">
                <div className="sectionTitle reveal">
                     Projects
                </div>
            </Row>
            <Row className="mx-0">
                <div className="sectionDescription reveal">
                    A selection of projects that demonstrate our capabilities and approach.
                </div>
            </Row>
            <Row className="portfolioGrid mx-0 justify-content-center">
                {projects.map((project, index) => (
                    <Col key={index} className="portfolioCard col-12 col-lg-6 reveal">
                        <div className="portfolioCardInner">
                            {project.clientImage ? (
                                <img src={project.clientImage} alt="Project" className="portfolioClientImage" />
                            ) : (
                                <div className="portfolioClient">{project.client}</div>
                            )}
                            <h3 className="portfolioTitle">{project.title}</h3>
                            {project.subtitle && <p className="portfolioSubtitle">{project.subtitle}</p>}
                            <p className="portfolioDescription">{project.description}</p>
                            <div className="portfolioTags">
                                {project.tags.map((tag, idx) => (
                                    <span key={idx} className="portfolioTag">{tag}</span>
                                ))}
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        </Row>
    )
}

export default Portfolio
